export default __webpack_public_path__ + "static/media/mindmap_01.6f358a62.png";